import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

// 登录注册等接口
export default {
  login(params) { // 用户登陆
    const url =  baseURL + '/tbUser/login';
    return axios.post(url, qs.stringify(params));
  },
  register(params) { // 用户注册
    const url =  baseURL + '/tbUser/userRegister';
    return axios.post(url, qs.stringify(params));
  },
  forget(params) { // 重置密码
    const url =  baseURL + '/tbUser/userPasswordReset';
    return axios.post(url, qs.stringify(params));
  },
  sendSmsCode(params) { // 获取手机验证码
    const url =  baseURL + '/tbUser/sendSmsCode';
    return axios.post(url, qs.stringify(params));
  },
  sendSmsCodeds(params) { // 注册获取手机验证码
    const url =  baseURL + '/tbUser/sendSmsCodeRegister';
    return axios.post(url, qs.stringify(params));
  },

  loginAdmin(params){
    // 管理员登录
    const url =  baseURL + '/tbAdminuser/adminUserlogin';
    return axios.post(url, qs.stringify(params));
  },
  createCode(params){
    // 管理员登录
    const url =  baseURL + '/tbUser/createCode';
    return axios.post(url, qs.stringify(params));
  },

  CheckTencentCaptcha(params){
    // 校验图片验证
    const url =  baseURL + '/tbUser/CheckTencentCaptcha';
    return axios.post(url, qs.stringify(params));
  },
  addApplyOn(params){
    // 提交试用申请
    const url =  baseURL + '/tbUsingapplication/modify';
    return axios.post(url, qs.stringify(params));
  },
  
}


// WEBPACK FOOTER //
// ./src/api/login.js